import { useState } from 'react'

import { Button } from 'antd'

import { browserRedirect } from '@eastcoal/common/utils/browser'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { SmsInput } from '@eastcoal/formily/components/SmsInput'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { SmsTemplateCode } from '@eastcoal/shared/enums/SmsTemplateCode'

import { useFormStyles } from '../style'

import { LoginSmsProps } from './interface'

const schema: SchemaItem[] = [
  {
    type: 'string',
    name: 'phone',
    'x-component': Input,
    'x-component-props': {
      placeholder: '手机号'
    },
    'x-decorator': FormItem,
    'x-validator': [
      {
        required: true,
        message: '请填写手机号'
      },
      {
        format: 'phone',
        triggerType: 'onBlur',
        message: '请输入正确的手机号'
      }
    ]
  },
  {
    type: 'object',
    name: '{code,ticketId}',
    'x-component': SmsInput,
    'x-component-props': {
      captchaEnabled: true,
      templateCode: SmsTemplateCode.LOGIN,
      placeholder: '验证码',
      comment: '登录',
      phone: '{{$values.phone}}'
    },
    'x-decorator': FormItem,
    'x-validator': {
      required: true,
      message: '请输入验证码'
    }
  }
]

export const LoginSms = ({ api }: LoginSmsProps) => {
  const form = useCreationForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = () => {
    form.submit(async values => {
      try {
        setLoading(true)
        await api(values)
        browserRedirect()
      } finally {
        setLoading(false)
      }
    })
  }

  const { styles } = useFormStyles()

  return (
    <SchemaForm
      className={styles.form}
      form={form}
      name='loginSmsForm'
      schema={schema}
      grid={{
        columns: 1
      }}
      layout={{
        labelWidth: '4rem'
      }}
      onSubmit={handleSubmit}
    >
      <Button
        block
        className={styles.submitBtn}
        htmlType='submit'
        loading={loading}
        type='primary'
      >
        登录
      </Button>
    </SchemaForm>
  )
}
